import styled from 'styled-components'

export const SectionDescription = styled.div`
  margin-bottom: var(--space-400);
`

export const SectionInput = styled.div`
  max-width: 560px;
`
